import { fromBool } from '@execonline-inc/maybe-adapter';
import { observer } from 'mobx-react';
import * as React from 'react';
import ChatMessageStore from '../../ChatMessageStore';
import ChatEditor from '../TeamProfile/TeamChat/StyleControls/ChatEditor';
import ChatEditorProvider from '../TeamProfile/TeamChat/StyleControls/ChatEditorProvider';
import * as style from './style.module.css';

interface Props {
  store: ChatMessageStore;
}

const CoachChatMessageForm: React.FC<Props> = ({ store }) => {
  const submitChatMessage = () =>
    store.message.andThen((m) => fromBool(m.text.length > 0, m)).do(store.updating);

  return (
    <div className={style.formWrapper}>
      <ChatEditorProvider>
        <form className={style.form}>
          <div className={style.textarea}>
            <ChatEditor
              store={store}
              submitChatMessage={submitChatMessage}
              placeholder="Send a message to this room..."
              readOnly={store.state.kind === 'updating'}
              contentClassName={style.editorContent}
            />
          </div>
        </form>
      </ChatEditorProvider>
    </div>
  );
};
export default observer(CoachChatMessageForm);
